import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus';
import { TypedMemo } from '../../common/types';
import { SMLPageHead } from '../../music24/components/SMLPageHead/SMLPageHead';
import { SMLButton } from '../../music24/components/primitives/SMLButton';
import { smlNavigationGroupMessages } from '../../music24/navigation/smlNavigationMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import styles from './Catalog.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface CatalogPageHeadProps {
  /** Opens the step-by-step "Add a song" page (design catalog-add-song h4). */
  onAddSong: () => void;
}

/** The head of the Catalog screen: breadcrumbs, title, subtitle and "Add a song". */
const CatalogPageHeadComponent: React.FC<CatalogPageHeadProps> = ({ onAddSong }) => {
  const intl = useIntl();

  const breadcrumbs = useMemo(
    () => [
      { name: intl.formatMessage(smlNavigationGroupMessages.yoursName) },
      { name: intl.formatMessage({ id: 'app.sml.sidebar.catalog', defaultMessage: 'Catalog' }) },
    ],
    [intl]
  );

  return (
    <SMLPageHead
      breadcrumbs={breadcrumbs}
      title={intl.formatMessage({ id: 'app.sml.sidebar.catalog', defaultMessage: 'Catalog' })}
      subtitle={intl.formatMessage({
        id: 'app.sml.catalog.subtitle',
        defaultMessage:
          'Everything MUSIC24 will let you promote. Claim what is yours — a connected service confirms it, but never gates it.',
      })}
    >
      <div className={styles.headActions}>
        <SMLButton variant="primary" icon={<FontAwesomeIcon icon={faPlus} />} onClick={onAddSong}>
          {intl.formatMessage({ id: 'app.sml.catalog.action.addSong', defaultMessage: 'Add a song' })}
        </SMLButton>
      </div>
    </SMLPageHead>
  );
};

export const CatalogPageHead = TypedMemo(CatalogPageHeadComponent);
